import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_TIME_SLOTS_BY_ID } from "../../../../../queries/v3/queries/get-time-slots-by-id.js";
import { fromTimeSlotsQueryToTimeSlots } from "../../../adapters/v3/hooks/api/adapters/fromTimeSlotsQueryToTimeSlots.js";
const useTimeSlotsById = (props = {}) => {
  const timeSlotsMetadataRef = React.useRef();
  const [timeSlotsMetadata, setTimeSlotsMetadata] = React.useState();
  const { locale } = useIntl();
  const { timeFilters } = props;
  const [query, queryState] = useLazyQuery(
    GET_TIME_SLOTS_BY_ID,
    {
      fetchPolicy: "no-cache",
      context: {
        forwardHeaders: {
          "Accept-Language": locale
        }
      },
      onCompleted: (data2) => {
        if (data2?.timeSlots && timeSlotsMetadataRef.current) {
          setTimeSlotsMetadata(timeSlotsMetadataRef.current);
          return;
        }
        setTimeSlotsMetadata(void 0);
      }
    }
  );
  const data = React.useMemo(() => {
    return queryState.data?.timeSlots ? fromTimeSlotsQueryToTimeSlots(queryState.data.timeSlots) : null;
  }, [queryState]);
  const filtered = React.useMemo(() => {
    const result = {
      included: [],
      excluded: []
    };
    if (!data) {
      return result;
    }
    const sorted = data.sort((a, b) => a.from.getTime() - b.from.getTime());
    if (!timeFilters?.length) {
      result.included = sorted;
      return result;
    }
    return sorted.reduce((acc, timeSlot) => {
      const include = timeFilters.some((filter) => filter(timeSlot.from));
      if (include) {
        acc.included.push(timeSlot);
      } else {
        acc.excluded.push(timeSlot);
      }
      return acc;
    }, result);
  }, [timeFilters, data]);
  const getTimeSlotsQuery = React.useCallback(
    (options, timeSlotsMetadata2) => {
      timeSlotsMetadataRef.current = timeSlotsMetadata2;
      query(options);
    },
    [query]
  );
  return React.useMemo(
    () => [
      getTimeSlotsQuery,
      {
        ...queryState,
        data,
        filtered,
        metadata: timeSlotsMetadata
      }
    ],
    [data, filtered, timeSlotsMetadata, queryState, getTimeSlotsQuery]
  );
};
export {
  useTimeSlotsById as default
};
//# sourceMappingURL=use-time-slots-by-id.js.map
